import { useEffect } from "react";
import {
  useChangeEmailGetTokenQuery,
  useChangeEmailConfirmMutation,
} from "../../store/services/user";
import { updateEmail } from "../../store/reducers/user";
import { useDispatch } from "react-redux";
import { compareAsc } from "date-fns";
import { useParams, useNavigate } from "react-router-dom";
import { toastSuccess } from "../../utils/toasts";
import { ROUTES } from "../../routes";
import { useTriggerToastOnRTKError } from "../../hooks/useTriggerToastOnRTKError";

export interface RequestType {
  token?: string;
}

export const NewEmailConfirmationPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { token } = useParams();
  const {
    data,
    isError: isErrorOnGetToken,
    error: errorOnGetToken,
  } = useChangeEmailGetTokenQuery({ token });

  const [
    changeEmailConfirm,
    { isUninitialized, isSuccess, isLoading, isError },
  ] = useChangeEmailConfirmMutation();

  useTriggerToastOnRTKError(isErrorOnGetToken, errorOnGetToken);

  useEffect(() => {
    const requestActivation = async (data: RequestType) =>
      await changeEmailConfirm(data);
    if (isUninitialized && data?.new_email) {
      requestActivation({ token });
    }
  }, [changeEmailConfirm, token, isUninitialized, data]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(updateEmail(data?.new_email));
      navigate(ROUTES.HOME);
      toastSuccess("Email updated");
    }

    if (
      data?.expires_at &&
      compareAsc(new Date(data?.expires_at), new Date()) === -1
    ) {
      navigate(ROUTES.LINK_EXPIRED);
    }

    // TODO: error handler for another errors
  }, [
    isSuccess,
    isLoading,
    isError,
    navigate,
    dispatch,
    data?.expires_at,
    data?.new_email,
  ]);

  return <></>;
};
